var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "bulma-table",
        {
          staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          attrs: {
            columns: _vm.columns,
            "page-index": 1,
            "page-size": 100,
            "total-rows": _vm.activeItems.length,
            "show-pagination": false,
            "is-loading": _vm.isTableLoading,
            "sort-column": _vm.sortColumn,
            "sort-order": _vm.sortOrder,
          },
          on: { sort: _vm.sort },
        },
        [
          _vm._l(_vm.activeItems, function (item, index) {
            return _c(
              "tr",
              {
                key: item.purchaseOrderItemId,
                class: { "is-selected": _vm.selectedRow === index },
              },
              [
                _c("td", { staticClass: "itemno-input" }, [
                  _vm._v(_vm._s(item.itemNo)),
                ]),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle itemdesc-input" },
                  [_vm._v(_vm._s(item.description))]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-right money-input",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumber(
                          item.dealerCost,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [_vm._v(_vm._s(item.receivedQty - item.returnQty))]
                ),
              ]
            )
          }),
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ]),
          _c("template", { slot: "footer" }, [
            _c(
              "tr",
              {
                staticClass: "no-border",
                class: [
                  _vm.miscsTotal >= 0
                    ? `purchase-order-background-success-${_vm.$theme.name}`
                    : `purchase-order-background-danger-${_vm.$theme.name}`,
                ],
              },
              [
                _c(
                  "th",
                  { staticClass: "has-text-left", attrs: { colspan: "2" } },
                  [_vm._v("Totals")]
                ),
                _c("th", { staticClass: "has-text-right" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatCurrency(
                        _vm.miscsTotal,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]),
                _c("th", { attrs: { colspan: "2" } }),
              ]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }